import type { ExpressionSpecification } from "maplibre-gl";
import { CITY_FLOODPRO, FEMA_MSC, fillLayers, pick, type LayerStyle } from "./types";

// City of Austin Atlas 14 "fully developed" floodplains: the 25-year floodplain is the stricter
// one (it governs development), so it gets the stronger colour.
const YR25 = "#d9480f";
const YR100 = "#aa711d";
const FEMA_IN_CITY = "#2f855a";

const color: ExpressionSpecification = [
  "case",
  ["==", ["index-of", "25-Year", ["to-string", ["get", "FLOOD_ZONE"]]], -1],
  ["case", ["==", ["index-of", "100-Year", ["to-string", ["get", "FLOOD_ZONE"]]], -1], FEMA_IN_CITY, YR100],
  YR25,
];

const style: LayerStyle = {
  id: "coa-floodplain-atlas14",
  minzoom: 10,
  maxzoom: 15,
  layers(source) {
    return fillLayers(this, source, color, 0.3);
  },
  legend: [
    { label: "25-year floodplain (fully developed)", color: YR25 },
    { label: "100-year floodplain (fully developed)", color: YR100 },
    { label: "Other mapped zone (A, AE, AO, shallow)", color: FEMA_IN_CITY },
  ],
  describe: (p) =>
    pick(p, [
      ["FLOOD_ZONE", "Floodplain"],
      ["FLOODWAY", "Floodway", (v) => (String(v).toUpperCase() === "FLOODWAY" ? "Yes" : "No")],
      ["SOURCE_CITATION", "Study"],
    ]),
  links: [CITY_FLOODPRO, FEMA_MSC],
};

export default style;
